export default function ({state, commit, dispatch}) {
    return new Promise(async resolve => {
        await dispatch('get');
        resolve(state)
    })
}